import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router";
import rawConfig from "virtual:app-config";
import { App } from "./App";
import { isAuthResponseWindow } from "./auth/popup";
import { configProblems, demoEntryRequested, entryUrl, resolveConfig } from "./config";
import { MessagePage } from "./shell/Login";
import { createStore } from "./store";

const root = createRoot(document.getElementById("root")!);

async function start() {
  // See ./auth/popup.ts: inside the Microsoft sign-in popup the app must stay out of the way.
  if (isAuthResponseWindow()) {
    root.render(
      <p className="splash" role="status">
        Signing you in…
      </p>,
    );
    return;
  }

  const config = resolveConfig(rawConfig);
  const demo = demoEntryRequested(window.location.search);
  const problems = configProblems(demo ? { ...config, apiBaseUrl: "" } : config);
  if (problems.length) {
    root.render(<MessagePage title="Setup needed">{`${problems.join(" ")} See the README.`}</MessagePage>);
    return;
  }

  const store = await createStore(config, demo);
  const enterDemo = config.apiBaseUrl
    ? () => {
        window.location.assign(entryUrl(window.location.href, true));
      }
    : undefined;
  const exitDemo =
    demo && config.apiBaseUrl
      ? () => {
          void store.signOut().finally(() => window.location.assign(entryUrl(window.location.href, false)));
        }
      : undefined;
  root.render(
    <StrictMode>
      <HashRouter>
        <App store={store} onEnterDemo={enterDemo} onExitDemo={exitDemo} />
      </HashRouter>
    </StrictMode>,
  );
  await store.init();
}

void start();
